module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div id='legend' class='gisstand-legend'>\n    <div class='gisstand-legend-head gl-pointer collapsed' style=\"padding-right: 40px;\" on-click='onLegendClick'>\n        ")
    ; __append(escapeFn( widget.title ))
    ; __append("\n    </div>\n    <div class='gisstand-legend-body' style=\"display: none;\" name=\"items\"></div>\n</div>")
  }
  return __output.join("");

}